export default function add (data) {
  return { type: 'add', ...data }
}